import React from 'react'

import DefaultCard from '@/molecules/Card/Cards/DefaultCard'

const ChefSecretsCard = ({ item }) =>(
  <DefaultCard {...item} />
)

export default ChefSecretsCard
